import React from "react";
import styles from "./ToggleSwitch.module.css";

const ToggleSwitch = ({ checked, onChange, labelOn, labelOff }) => {
  return (
    <div className={styles["toggle-container"]}>
      <label className={styles["toggle-switch"]}>
        <input 
          type="checkbox" 
          checked={checked} 
          onChange={onChange} 
        />
        <span className={styles["slider"]} />
      </label>
      <div className={styles["toggle-label"]}>
        {checked ? <span>{labelOn}</span> : <span>{labelOff}</span>}
      </div>
    </div>
  );
};

export default ToggleSwitch;
